import React, {Component, createRef} from 'react';
import { responsiveFontSize, responsiveHeight } from '../Services/Utilities';

const DEFAULT_STROKE_WIDTH = 1
const DEFAULT_STROKE_COLOR = '#006080'
const DEFAULT_DASHED_COLOR = 'orange'

const DEFAULT_CONNECTION_LINE_STROKE_WIDTH = 1
const DEFAULT_CONNECTION_LINE_COLOR = 'rgba(0, 96, 128, 0.5)'

const DEFAULT_SLIDER_DOT_COLOR = 'rgba(0, 96, 128, 0.5)'

const DEFAULT_TIP_SIZE = 10
const N_STEPS = 6

class PlayStatisticsDrawingComponent extends Component {
    
    constructor(props){
        super(props)
        
        this.canvasRef = createRef()

        this.state = {
            ctx: undefined,
            allowDrawing: false,

            canvasHeight:0,
            canvasWidth:0,
            points : [[]],
            correctPoints : [[]],
            dates:[],
            cursorType:'default',
            showCorrectData: true,
            offset:0
        }

        this.drawPlot = this.drawPlot.bind(this)
        this.drawPoint = this.drawPoint.bind(this)
        this.drawPoints = this.drawPoints.bind(this)
        this.drawLine = this.drawLine.bind(this)
        this.drawLineSeperation = this.drawLineSeperation.bind(this)
        this.drawAxis = this.drawAxis.bind(this)
        this.drawAxisLabels = this.drawAxisLabels.bind(this)
        this.drawDateLabels = this.drawDateLabels.bind(this)
        this.drawYGrid = this.drawYGrid.bind(this)

        this.convertPointsToOriginAndScale = this.convertPointsToOriginAndScale.bind(this)
        

    }

    componentDidMount(){
        if(this.canvasRef){
            let ctx = this.canvasRef.current.getContext('2d')

            let strokeWidth = this.props.strokeWidth || DEFAULT_STROKE_WIDTH
            let strokColor = this.props.strokColor || DEFAULT_STROKE_COLOR

            const { width, height} = this.props.style;
            const { data, dataCorrect, dates} = this.props;

            let offset = DEFAULT_TIP_SIZE

            this.setState({
                ctx: ctx,
                allowDrawing: true,
                strokeWidth:strokeWidth,
                strokColor: strokColor,

                canvasWidth: width,
                canvasHeight: height,

                offset: offset,
                points:data ,
                correctPoints: dataCorrect,
                dates:dates,

            }, () => this.drawPlot())

            
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.canvasRef){
            const {ctx, canvasWidth, canvasHeight, offset} = this.state;
            const {data, dataCorrect} = nextProps;

            if(!ctx) return;   

            this.setState({
                points: data,
                correctPoints:dataCorrect
            }, () => this.drawPlot())
                       
        }
    }

    drawPlot() {
        const {ctx} = this.state;
        if(!ctx) return;      

        const {points, correctPoints,dates, canvasWidth, canvasHeight, strokColor, strokeWidth, offset, showCorrectData} = this.state;
        const {xAxisLabel, yAxisLabel} = this.props;

        ctx.clearRect(0, 0, canvasWidth + offset * 6, canvasHeight + offset * 8);

        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasWidth + offset * 6, canvasHeight + offset * 8);

        //get x and y-decimleRange
        const xDecimalRange = canvasWidth
        const yDecimalRange = canvasHeight

        this.drawAxis(xDecimalRange,yDecimalRange)
        this.drawAxisLabels(xAxisLabel, yAxisLabel, xDecimalRange, yDecimalRange)
        
        //unpack data
        const xData = points.map((d) => d[0])
        const yData = points.map((d) => d[1])

        //data length check
        if(xData.length != yData.length){
            console.log("data not same length")
            return
        }

        //convert data to new scale 
        //1- determin y values range and then change data to new origin axis
        let {minYData, maxYData, 
            minXData, maxXData, 
        } = this.calculateNumericGridResolution(xData, yData)
       

        this.drawPoints(points, xDecimalRange, maxXData, yDecimalRange, maxYData, 'rgba(0, 0, 0, 0.1)', 'rgba(0, 96, 128, 0.5)')
        
        if(showCorrectData){
            this.drawPoints(correctPoints, xDecimalRange, maxXData, yDecimalRange, maxYData, 'rgba(0, 0, 0, 0.1)', 'rgba( 0, 153, 0, 0.5)')
        }        

        let dateLabels = this.getDateLabelsPositions(dates)
        this.drawDateLabels(dateLabels, xDecimalRange, maxXData, yDecimalRange, maxYData)

        this.drawYGrid(xDecimalRange, yDecimalRange, maxYData)

    }

    drawPoints(points,
        xDecimalRange, maxXValue,
        yDecimalRange, maxYValue,
        color='gray', fillColor = 'blue'
        ){

        let newPoints  = this.convertPointsToOriginAndScale(
            points,
            xDecimalRange, 
            maxXValue,
            yDecimalRange, 
            maxYValue
        )

        for(let d of newPoints){
            this.drawPoint(d, color, fillColor)
        }

        for(let i = 0; i < newPoints.length - 1; i++){
            let firstPoint = newPoints[i]
            let secondPoint = newPoints[i+1]
            this.drawLine(firstPoint, secondPoint)
        }
    }

    convertPointsToOriginAndScale(points,
        xDecimalRange, maxXValue,
        yDecimalRange, maxYValue){

        const {offset} = this.state

        const yOriginAxisConverstion = offset*2 + yDecimalRange
        const xOriginAxisConverstion = offset*4

        //convert scale
        let newPoints  = points.map((d) => [xDecimalRange*(d[0]/maxXValue), yDecimalRange*(d[1]/maxYValue)])

        //convert origin
        newPoints = newPoints.map((d) => [xOriginAxisConverstion + d[0],yOriginAxisConverstion - d[1]])

        return newPoints

        }

    drawPoint(point, color, fillColor){
        const {ctx} = this.state;
        if(!ctx) return;      

        ctx.beginPath();
        ctx.arc(point[0], point[1], DEFAULT_TIP_SIZE*0.3, 0, 2 * Math.PI);
        ctx.strokeStyle = color;
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.stroke();
    }

    drawAxisLabels(xAxisLabel, yAxisLabel, xDecimalRange, yDecimalRange){
        const {ctx, offset, canvasHeight, canvas} = this.state;
        if(!ctx) return;  

        ctx.fillStyle = "black";
        ctx.font = "12px Arial";
        ctx.fillText(xAxisLabel, xDecimalRange, yDecimalRange+ 6*offset)

        ctx.font = "12px Arial";
        ctx.fillText(yAxisLabel, offset, offset*1.5)
    }

    drawDateLabels(labels, xDecimalRange, maxXValue, yDecimalRange, maxYValue){
        const {ctx, offset} = this.state;
        if(!ctx) return;  

        let labelKeys = Object.keys(labels)

        let datesLength = 0
        let prevPoint = [[0,0], [0,0]]

        for(let dLabel of labelKeys){
            const data = labels[dLabel]
            datesLength = datesLength + data.dates.length
          
            let points = [[datesLength-1,0],
                        [datesLength-1, maxYValue]]
            
            
            points = this.convertPointsToOriginAndScale(
                points,
                xDecimalRange, 
                maxXValue,
                yDecimalRange, 
                maxYValue
            )

            this.drawLineSeperation(
                points[0],
                points[1],
            )

            ctx.font = "12px Arial";
            let labelPosition = (points[0][0] + prevPoint[0][0])/2

            ctx.fillStyle  = "black";
            ctx.fillText(data.month + "-" + data.year, labelPosition,  yDecimalRange+ 4*offset)

            prevPoint = points

        }
    }

    drawAxis(xDecimalRange, yDecimalRange, xAxisColor="gray", yAxisColor="gray"){
        const {ctx, offset} = this.state;
        if(!ctx) return;      

        //x-axis
        ctx.beginPath();
        ctx.moveTo(offset*4, yDecimalRange+offset*2);
        ctx.lineTo(offset*4+xDecimalRange, yDecimalRange+offset*2);
        ctx.strokeStyle = xAxisColor;
        ctx.lineWidth = 1
        ctx.stroke();

        //y-axis
        ctx.beginPath();
        ctx.moveTo(offset*4, yDecimalRange+offset*2);
        ctx.lineTo(offset*4, offset*2);
        ctx.strokeStyle = yAxisColor;
        ctx.lineWidth = 1 
        ctx.stroke();
    }

    drawYGrid(xDecimalRange, yDecimalRange, maxYValue){
        const {ctx, offset} = this.state;
        if(!ctx) return;      

        let scales = [1,2,4, 8, 16]

        for(let s of scales){
            const ratio = (1-1/s)

            ctx.beginPath();
            ctx.moveTo(offset*4, offset*2 + yDecimalRange * ratio);
            ctx.lineTo(offset*4+xDecimalRange, offset*2 + yDecimalRange * ratio);
            ctx.strokeStyle = 'rgba(0, 0, 0, 0.1)';
            ctx.lineWidth = 1
            ctx.stroke();

            ctx.fillStyle  = "black";
            ctx.fillText(Math.floor(maxYValue/s), offset*4, offset*2 + yDecimalRange * ratio + DEFAULT_TIP_SIZE)
            ctx.fillStyle  = "white";
            ctx.fillText("", 0, 0)


        }

       

    }

    drawLine(startPoint, endPoint,){
        const {ctx} = this.state;
        if(!ctx) return;      

        ctx.beginPath();

        ctx.moveTo(...startPoint);
        ctx.lineTo(...endPoint);

        ctx.strokeStyle = 'rgba(0, 0, 0, 0.1)';
        ctx.lineWidth = 1 

        ctx.stroke();
        ctx.setLineDash([])
    }

    drawLineSeperation(startPoint, endPoint,){
        const {ctx} = this.state;
        if(!ctx) return;      

        ctx.beginPath();

        ctx.moveTo(...startPoint);
        ctx.lineTo(...endPoint);

        ctx.strokeStyle = 'rgba(255, 0, 0, 0.2)';
        ctx.lineWidth = 1 

        ctx.stroke();
        ctx.setLineDash([])
    }

    calculateNumericGridResolution(xData, yData){
        let minXData = Math.min(...xData) 
        let maxXData = Math.max(...xData)

        let minYData = Math.min(...yData) 
        let maxYData = Math.max(...yData)

        return {
            minYData: minYData,
            maxYData: maxYData,

            minXData: minXData,
            maxXData: maxXData,
        }
    }

    
    getDateLabelsPositions(dates){
        const result = dates.reduce((r, date) => {
            const [year, month, day] = date.substr(0,10).split('-');
            const key = `${year}_${month}`;

            let monthName = new Date();
            monthName.setMonth(month - 1);

            monthName = monthName.toLocaleString('en-US', { month: 'long' });

            r[key] = r[key] || {month, year,monthName, dates: []};
            r[key].dates.push(day);
            return r;
          },{})

        return result
    }


    render(){
        return (
            <div style = {{flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center'}}>
                <div 
                className= {this.props.borderClass || "border"}
                style = {{
                    flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center'}}>
                    <canvas
                    id="canvas"
                        style = {{
                            ...this.props.style, cursor: this.state.cursorType,
                            height:this.props.style.height + this.state.offset * 8,
                            width:this.props.style.width + this.state.offset * 6
                        }}

                        width = {this.props.style.width + this.state.offset * 6}
                        height = {this.props.style.height + this.state.offset * 8}

                        ref = {this.canvasRef}

                        onMouseMove = {this.handleMouseMove}
                        onMouseLeave = {() => this.setState({cursorType:'default'})}
                        onClick = {this.handleMouseClick}
                    />
                </div>
                <p style = {{textAlign:'left', cursor:'pointer', width:'100%', marginBottom: responsiveHeight(1)}}
                onClick = {() => {
                    this.setState(prev => ({
                        showCorrectData: !prev.showCorrectData
                    }), () => this.drawPlot())
                }}
                > {this.state.showCorrectData ? "Hide":"Show"} correct data</p>
                <p style = {{textAlign:'left', cursor:'pointer', width:'100%'}}
                onClick = {() => {
                    const canvas = document.getElementById("canvas")
                    let canvasUrl = canvas.toDataURL();
                    // Create an anchor, and set the href value to our data URL
                    const createEl = document.createElement('a');
                    createEl.href = canvasUrl;

                    // This is the name of our downloaded file
                    createEl.download = "games_played_report";

                    // Click the download button, causing a download, and then remove it
                    createEl.click();
                    createEl.remove();
                }}
                >click to download</p>
            </div>
        );
    }

    
}

export default PlayStatisticsDrawingComponent